'use strict';

let printing = false;
const beforeCallbacks = [];
const afterCallbacks = [];

function execute(callbacks) {
    for (var i = 0; i < callbacks.length; ++i) {
        callbacks[i].call();
    }
}

function toggle(before) {
    if (before) {
        if (!printing) {
            printing = true;
            execute(beforeCallbacks);
        }
    } else {
        if (printing) {
            printing = false;
            execute(afterCallbacks);
        }
    }
}

window.addEventListener('beforeprint', function () {
    toggle(true);
});

window.addEventListener('afterprint', function () {
    toggle(false);
});

// noinspection JSDeprecatedSymbols
window.matchMedia('print').addListener(function (mql) {
    toggle(mql.matches);
});

export default function add(before, after) {
    if (typeof before === 'function') {
        beforeCallbacks.push(before);
    }
    if (typeof after === 'function') {
        afterCallbacks.push(after);
    }
}